import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-auditoria",
  templateUrl: "./auditoria.component.html",
  styleUrls: ["./auditoria.component.scss"]
})
export class AuditoriaComponent implements OnInit {
  constructor() {}

  optionsModulo: Array<any> = [];

  ngOnInit() {
    this.optionsModulo = [
      { value: "1", label: "Modulo 1" },
      { value: "2", label: "Modulo 2" },
      { value: "3", label: "Modulo 3" }
    ];
  }
}
